import { render } from "./LbrxCalendarView.vue?vue&type=template&id=608466b4"
import script from "./LbrxCalendarView.vue?vue&type=script&lang=js"
export * from "./LbrxCalendarView.vue?vue&type=script&lang=js"

import "./LbrxCalendarView.vue?vue&type=style&index=0&id=608466b4&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__